import { css as _css } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import Text from "../Text";
import useBackground, { BackgroundProvider, mapResponsiveValues } from "../../hooks/useBackground";
import useTheme from "../../hooks/useTheme";
import { responsiveMaxHeightType } from "../../hooks/useResponsiveProp";
import useResponsivePropsCSS from "../../hooks/useResponsivePropsCSS";
import { responsiveSize } from "../../utils/css";
import { jsx as ___EmotionJSX } from "@emotion/core";
var COLORS = ["grey.t05", "white"];

function DropdownDefaultPlaceholder() {
  return ___EmotionJSX(Text, null, "Please select");
}

var DEFAULT_PROPS = {
  color: "grey.t05",
  placeholderComponent: DropdownDefaultPlaceholder,
  disabled: false,
  isValid: true,
  maxHeight: "600",
  __internal__focus: false,
  __internal__open: false
};
InternalDropdown.COLORS = COLORS;
InternalDropdown.DEFAULT_PROPS = DEFAULT_PROPS;

function InternalDropdown(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var name = props.name,
      parentName = props.parentName,
      PlaceholderComponent = props.placeholderComponent,
      OptionComponent = props.optionComponent,
      options = props.options,
      selectedOption = props.selectedOption,
      isOpen = props.isOpen,
      toggleButtonProps = props.toggleButtonProps,
      getMenuProps = props.getMenuProps,
      getItemProps = props.getItemProps,
      highlightedIndex = props.highlightedIndex,
      onFocus = props.onFocus,
      __internal__focus = props.__internal__focus,
      __internal__open = props.__internal__open,
      __internal__highlightedIndex = props.__internal__highlightedIndex;
  var theme = useTheme();

  var _useBackground = useBackground(),
      inputColorMap = _useBackground.inputColorMap;

  var colorMap = mapResponsiveValues(inputColorMap, function (inputColor) {
    var _props$color;

    return (_props$color = _props.color) !== null && _props$color !== void 0 ? _props$color : inputColor;
  }, theme);
  var buttonCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    color: function color(propsAtBreakpoint, theme, bp) {
      return theme.dropdown.getCSS({
        targetElement: "button",
        color: colorMap[bp],
        isPlaceholder: !selectedOption,
        __internal__focus: __internal__focus
      });
    }
  });
  var optionsCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    maxHeight: responsiveSize("maxHeight")
  });
  var menuProps = getMenuProps({
    "data-parent-name": parentName !== null && parentName !== void 0 ? parentName : name,
    onFocus: onFocus
  });
  return ___EmotionJSX("div", {
    css: theme.dropdown.getCSS({
      targetElement: "container"
    })
  }, ___EmotionJSX("button", _extends({
    css: buttonCSS,
    type: "button",
    name: name,
    "data-parent-name": parentName !== null && parentName !== void 0 ? parentName : name
  }, toggleButtonProps), ___EmotionJSX(BackgroundProvider, {
    value: colorMap
  }, ___EmotionJSX("div", {
    css: theme.dropdown.getCSS({
      targetElement: "buttonContent"
    })
  }, selectedOption ? ___EmotionJSX(OptionComponent, selectedOption) : ___EmotionJSX(PlaceholderComponent, null)), ___EmotionJSX("div", {
    css: theme.dropdown.getCSS({
      targetElement: "buttonChevron"
    })
  }, ___EmotionJSX(Icon, {
    name: "triangle-down",
    color: "black"
  })))), ___EmotionJSX("ul", _extends({
    css: /*#__PURE__*/_css(_objectSpread(_objectSpread({}, theme.dropdown.getCSS({
      targetElement: "options"
    })), optionsCSS), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }, menuProps), ___EmotionJSX(BackgroundProvider, {
    value: "white"
  }, (isOpen || __internal__open) && options.map(function (option, index) {
    return ___EmotionJSX("li", _extends({
      css: theme.dropdown.getCSS({
        targetElement: "option",
        isHighlighted: (__internal__highlightedIndex !== null && __internal__highlightedIndex !== void 0 ? __internal__highlightedIndex : highlightedIndex) === index
      })
    }, getItemProps({
      item: option,
      index: index
    }), {
      key: index
    }), ___EmotionJSX(OptionComponent, option));
  }))));
}

InternalDropdown.propTypes = _objectSpread(_objectSpread({
  name: PropTypes.string.isRequired,
  parentName: PropTypes.string,
  // While Dropdown doesn't pass a parentName, a composite component that contains an InternalDropdown would.
  color: PropTypes.oneOf(COLORS),
  PlaceholderComponent: PropTypes.func,
  optionComponent: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  selectedOption: PropTypes.shape({
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
  }),
  isOpen: PropTypes.bool.isRequired,
  toggleButtonProps: PropTypes.object.isRequired,
  getMenuProps: PropTypes.func.isRequired,
  getItemProps: PropTypes.func.isRequired,
  highlightedIndex: PropTypes.number.isRequired,
  onFocus: PropTypes.func.isRequired
}, responsiveMaxHeightType), {}, {
  __internal__focus: PropTypes.bool,
  __internal__open: PropTypes.bool,
  __internal__highlightedIndex: PropTypes.number
});
export default InternalDropdown;